__turbopack_context__.v({
  "confirm": "ProspectActions-module__3hD9bq__confirm",
  "confirmInfo": "ProspectActions-module__3hD9bq__confirmInfo",
  "history": "ProspectActions-module__3hD9bq__history",
  "historyAction": "ProspectActions-module__3hD9bq__historyAction",
  "historyActions": "ProspectActions-module__3hD9bq__historyActions",
  "historyDate": "ProspectActions-module__3hD9bq__historyDate",
  "historyDelete": "ProspectActions-module__3hD9bq__historyDelete",
  "historyEmpty": "ProspectActions-module__3hD9bq__historyEmpty",
  "historyItem": "ProspectActions-module__3hD9bq__historyItem",
  "historyLabel": "ProspectActions-module__3hD9bq__historyLabel",
  "historyMeta": "ProspectActions-module__3hD9bq__historyMeta",
  "historyNote": "ProspectActions-module__3hD9bq__historyNote",
  "historyPagination": "ProspectActions-module__3hD9bq__historyPagination",
  "select": "ProspectActions-module__3hD9bq__select",
  "selectAgo": "ProspectActions-module__3hD9bq__selectAgo",
  "selectLabel": "ProspectActions-module__3hD9bq__selectLabel",
});
